import { CustomLevel, ValidationResult } from './EditorTypes';

export function validateLevel(level: CustomLevel): ValidationResult {
  const errors: string[] = [];
  const warnings: string[] = [];
  const info: string[] = [];

  // Check for required entities
  const phantomCount = level.entities.filter(e => e.type === 'PHANTOM').length;
  const portalCount = level.entities.filter(e => e.type === 'PORTAL').length;

  if (phantomCount === 0) {
    errors.push('Level must have at least 1 PHANTOM (player character)');
  }
  
  if (portalCount === 0) {
    errors.push('Level must have at least 1 PORTAL (goal)');
  }

  if (phantomCount > 1) {
    warnings.push('Multiple PHANTOMs detected - only one will be controlled');
  }

  if (portalCount > 1) {
    warnings.push('Multiple PORTALs detected - reaching any will win the level');
  }

  // Check for required rules
  let hasPhantomIsYou = false;
  let hasPortalIsWin = false;

  Object.values(level.wordBoxes).forEach(dimensionWords => {
    const wordTypes = dimensionWords.map(w => w.type);
    
    // Check for "PHANTOM IS YOU" pattern
    for (let i = 0; i < wordTypes.length - 2; i++) {
      if (wordTypes[i] === 'WORD_PHANTOM' && 
          wordTypes[i + 1] === 'WORD_IS' && 
          wordTypes[i + 2] === 'WORD_YOU') {
        hasPhantomIsYou = true;
      }
    }

    // Check for "PORTAL IS WIN" pattern
    for (let i = 0; i < wordTypes.length - 2; i++) {
      if (wordTypes[i] === 'WORD_PORTAL' && 
          wordTypes[i + 1] === 'WORD_IS' && 
          wordTypes[i + 2] === 'WORD_WIN') {
        hasPortalIsWin = true;
      }
    }
  });

  if (!hasPhantomIsYou) {
    errors.push('Level must have "PHANTOM IS YOU" rule (player control)');
  }

  if (!hasPortalIsWin) {
    errors.push('Level must have "PORTAL IS WIN" rule (win condition)');
  }

  // Check for obstacles
  const obstacles = level.entities.filter(e => 
    e.type === 'BARRIER' || e.type === 'WATER' || e.type === 'FIRE'
  );
  
  if (obstacles.length === 0) {
    warnings.push('No obstacles - level might be too easy');
  }

  // Check for empty dimensions
  const emptyDimensions = [];
  for (let dim = 2; dim <= 4; dim++) {
    if (!level.wordBoxes[dim] || level.wordBoxes[dim].length === 0) {
      emptyDimensions.push(dim);
    }
  }

  if (emptyDimensions.length > 0) {
    warnings.push(`Empty dimensions: ${emptyDimensions.join(', ')}`);
  }

  // Info
  info.push(`Entities: ${level.entities.length}`);
  const totalWords = Object.values(level.wordBoxes).reduce((sum, words) => sum + words.length, 0);
  info.push(`Word boxes: ${totalWords}`);

  return {
    valid: errors.length === 0,
    errors,
    warnings,
    info
  };
}
